import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../Layouts/index";

import homedata from "../../data/Homepage";
import NavAndFooter from "../Common/NavAndFooterContainer";
import GetPageData from "../../hooks/GetPageData";
import LoadingComponet from "../../components/Loading/LoadingComponet";
import Div100vh from "react-div-100vh";
import AddPanchayatBtn from "../../components/Buttons/AddpanchyatBtn";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#ededed",
    [theme.breakpoints.down("md")]: {
      backgroundColor: "#ededed",
    },
  },
}));

const HomePage = () => {
  const classes = useStyles();
  const { ready, data, error } = GetPageData("home");
  return ready && data ? (
    // <Div100vh>
    <div className={classes.root}>
      <AddPanchayatBtn />

      {data?.data?.map((data, index) => {
        const Layout = layouts[data?.layout];
        return data && <Layout key={index} data={data} />;
      })}
    </div>
  ) : (
    // </Div100vh>
    <div>
      <LoadingComponet />
    </div>
  );
};
export default HomePage;
